import * as PIXI from "pixi.js";
import TextureManager from "../../../../src/managers/TextureManager";
import { QuasimodoPartial } from "../types/interface";


export default function addSprite(path: string, bounds: { width: number, height: number, scale: number }, anchor: { x: number, y: number }): QuasimodoPartial {
  const texture = TextureManager.getTexture(path);
  const sprite = new PIXI.Sprite(texture) as QuasimodoPartial;
  sprite.x = -1000;
  sprite.y = -1000;
  Object.assign(sprite, bounds);
  sprite.scaleValue = bounds.scale;
  sprite.anchor.set(anchor.x, anchor.y);
  return sprite;
}